import { Container } from 'typedi';
import { PostLoginActionNameEnum } from '@sparkware/uc-sdk-core';
import { PendingActionEnum } from '../../../models/enums/general-enums';
import { IPostLoginActionsState } from '../models/IPostLoginActionsState';
import { PostLoginActionBase } from './post-login-action-base';
import { PendingService } from '../../pending/pending.service';

export class CheckForPendingIdentityVerificationPostLoginAction extends PostLoginActionBase {
    private readonly _pendingService: PendingService;

    constructor(state: IPostLoginActionsState) {
        super(
            PostLoginActionNameEnum.CheckForPendingIdentityVerification,
            'CheckForPendingIdentityVerificationPostLoginAction',
            state,
        );
        this._pendingService = Container.get(PendingService);
    }

    protected override doAction = async (): Promise<boolean> => {
        const pendingActionId = PendingActionEnum.IdentityVerification;
        await this._pendingService.showPending({
            requestParams: {
                actionId: pendingActionId,
            },
            onClose: this.completeAction,
        });

        this.completeAction();
        return false;
    };
}
